import { ConnectShopifyModal } from './ConnectShopifyModal/ConnectShopifyModal';
import { MODALS_TYPE } from '@mm/state/modules/modalsState/types';
import AddEmailModal from '../../dashboard/pages/RegisterFlow/ConnectFacebook/AddEmailModal/AddEmailModal';
import AddMorePagesTeamModal from '../../dashboard/pages/SettingsPage/modals/AddMorePagesTeamModal/AddMorePagesTeamModal';
import BillingModal from '../../dashboard/pages/SettingsPage/modals/BillingModal/BillingModal';
import ConfirmManagePagesModal from '../../dashboard/pages/SettingsPage/modals/ConfirmManagePagesModal/ConfirmManagePagesModal';
import ConfirmSwapPagesModal from '../../dashboard/pages/SettingsPage/modals/ConfirmSwapPagesModal/ConfirmSwapPagesModal';
import ManagePagesModal from '../../dashboard/pages/SettingsPage/modals/ManagePagesModal/ManagePagesModal';
import SelectTeamPagesModal from '../../dashboard/pages/SettingsPage/modals/SelectTeamPagesModal/SelectTeamPagesModal';
import ButtonConfigForm from '../../editor/features/build/components/widgets/buttons/ButtonConfigform/ButtonConfigForm';
import MenuButtonConfigForm from '../../editor/features/build/components/widgets/buttons/MenuButtonConfigForm/MenuButtonConfigForm';
import { PlatformsFilterModal } from '../../editor/features/contacts/components/FilterModals/platformsFilterModal/platformsFilterModal';
import { ReachableModal } from '../../editor/features/contacts/components/FilterModals/reachableModal/reachableModal';
import VariableValuesModal from '../../editor/features/contacts/components/FilterModals/variableValuesModal/variableValuesModal';
import { InstagramMediaModal } from '../../editor/features/startBotPromoters/instagramCommentGuard/InstagramMediaModal/InstagramMediaModal';
import ImageUploadFormModal from '../components/ImageUpload/imageUploadFormModal/imageUploadFormModal';
import ActivateChannelsModal from './ActivateChannelsModal/ActivateChannelsModal';
import { ActivateEmailAccountModal } from './ActivateEmailAccountModal/ActivateEmailAccountModal';
import ActivateInactiveBotModal from './ActivateInactiveBotModal/ActivateInactiveBotModal';
import ActivateSMSNumberModal from './ActivateSMSNumberModal/ActivateSMSNumberModal';
import AddPromoterModal from './AddPromoterModal/AddPromoterModal';
import { AdminAccessRequiredModal } from './AdminAccessRequiredModal/AdminAccessRequired';
import AllSetModal from './AllSetModal/AllSetModal';
import { AudienceExtractorModal } from './AudienceExtractorModal/AudienceExtractorModal';
import { AudiencesSyncRestrictionsModal } from './AudiencesSyncRestrictionsModal/AudiencesSyncRestrictionsModal';
import { BotResponseSettingsModal } from './BotResponseSettingsModal/BotResponseSettingsModal';
import { CampaignExceedsSendLimitModal } from './CampaignExceedsSendLimitModal/CampaignExceedsSendLimitModal';
import { ChatbotLimitModal } from './ChatbotLimitModal/ChatbotLimitModal';
import { ChatWidgetPreviewModal } from './ChatWidgetPreviewModal/ChatWidgetPreviewModal';
import ConfirmChangeBotStatusModal from './ConfirmChangeBotStatusModal/ConfirmChangeBotStatusModal';
import ConfirmDeleteChatbotModal from './ConfirmDeleteChatbotModal/ConfirmDeleteChatbotModal';
import { ConfirmDeleteModal } from './ConfirmDeleteModal/ConfirmDeleteModal';
import ConfirmDowngradePromoModal from './ConfirmDowngradePromoModal/ConfirmDowngradePromoModal';
import ConfirmFbDowngradeModal from './ConfirmFbDowngradeModal/ConfirmFbDowngradeModal';
import ConfirmSendWelcomeMessageModal from './ConfirmSendWelcomeMessageModal/ConfirmSendWelcomeMessageModal';
import { ConfirmStoryMentionModal } from './ConfirmStoryMentionModal/ConfirmStoryMentionModal';
import ConnectedPageErrorModal from './ConnectedPageErrorModal/ConnectedPageErrorModal';
import { ConnectPagesFollowUpModal } from './ConnectPagesFollowUpModal/ConnectPagesFollowUpModal';
import ConnectPagesModal from './ConnectPagesModal/ConnectPagesModal';
import { ContactsExportModal } from '@mm/stateful-components';
import CreateBotModal from './CreateChatbotModal/CreateBotModal';
import { CreateCompanyModal } from './CreateCompanyModal/CreateCompanyModal';
import CustomAudienceErrorModal from './CreateFBCustomAudience/CustomAudienceErrorModal/CustomAudienceErrorModal';
import NoLinkedAdAccountModal from './CreateFBCustomAudience/NoLinkedAdAccountModal/NoLinkedAdAccountModal';
import DeactivateAffiliateModal from './DeactivateAffiliateModal/DeactivateAffiliateModal';
import { Dec2020FbApiEuropeChangesModal } from './Dec2020FbApiEuropeChangesModal/Dec2020FbApiEuropeChangesModal';
import { DialoguePickerModal } from './DialoguePickerModal/DialoguePickerModal';
import { NewDialoguePickerModal } from './DialoguePickerModal/NewDialoguePickerModal';
import { DialogueSettingsModal } from './DialogueSettingsModal/DialogueSettingsModal';
import DisconnectPageModal from './DisconnectPageModal/DisconnectPageModal';
import DowngradeFacebookPageModal from './DowngradeFacebookPageModal/DowngradeFacebookPageModal';
import { EmailSubmissionModal } from './EmailSubmissionModal/EmailSubmissionModal';
import { ExportModal } from './ExportModal/ExportModal';
import { FeatureActivationCongratsModal } from './FeatureActivationCongratsModal/FeatureActivationCongratsModal';
import { FreeTrialUpgradeModal } from './FreeTrialUpgradeModal/FreeTrialUpgradeModal';
import GeneralConfirmModal from './GeneralConfirmModal/GeneralConfirmModal';
import GeneralTextModal from './GeneralTextModal/GeneralTextModal';
import GetStartedOnboardingModal from './GetStartedOnboardingModal/GetStartedOnboardingModal';
import GrantPermissionsModal from './GrantPermissionsModal/GrantPermissionsModal';
import { ImportContactListModal } from './ImportContantListModal/ImportContantListModal';
import InstagramConnectModal from './InstagramConnectModal/InstagramConnectModal';
import { InviteUserModal } from './InviteUserModal/InviteUserModal';
import LinkAdAccountModal from './LinkAdAccountModal/LinkAdAccountModal';
import { MailchimpTestConnectionModal } from './MailchimpTestConnectionModal/MailchimpTestConnectionModal';
import { MigrateToInstachampThanksModal } from './MigrateToInstachampThanksModal/MigrateToInstachampThanksModal';
import { MobileDownload } from './MobileDownload/MobileDownload';
import MonthlySendsWarningModal from './MonthlySendsWarningModal/MonthlySendsWarningModal';
import { NewAudienceNamePromptModal } from './NewAudienceNamePromptModal/NewAudienceNamePromptModal';
import { PermissionsHelperModal } from './PermissionsHelperModal/PermissionsHelperModal';
import { PrettyErrorModal } from './PrettyErrorModal/PrettyErrorModal';
import { PromoBlasterModal } from './PromoBlasterModal/PromoBlasterModal';
import { QuickQuestionOptInModal } from './QuickQuestionOptIntModal/QuickQuestionOptInModal';
import RefreshAccessTokenErrorModal from './RefreshAccessTokenErrorModal/RefreshAccessTokenErrorModal';
import { RemoveUserModal } from './RemoveUserModal/RemoveUserModal';
import { SelectFacebookPageModal } from './SelectFacebookPageModal/SelectFacebookPageModal';
import { SendTestEmailModal } from './SendTestEmailModal/SendTestEmailModal';
import ShareBotModal from './ShareBotModal/ShareBotModal';
import { SpreadsheetTestConnectionModal } from './SpreadsheetTestConnectionModal/SpreadsheetTestConnectionModal';
import { SubscriptionPausingModal } from './SubscriptionPausingModal/SubscriptionPausingModal';
import TestConnectionModal from './TestConnectionModal/TestConnectionModal';
import { UniversalUpgradeModal } from './UniversalUpgradeModal/UniversalUpgradeModal';
import { ConnectChannelModal } from './ConnectChannelModal/ConnectChannelModal';
import { SubscribeAfterTrialPromoModal } from './SubscribeAfterTrialPromoModal/SubscribeAfterTrialPromoModal';
import { VerifyEmailModal } from './VerifyEmailModal/VerifyEmailModal';
import { CloneAutomationModal } from '../../editor/features/beta/modules/Automations/AutomationEdit/CloneAutomationModal/CloneAutomationModal';
import { ImportAutomationModal } from '../../editor/features/beta/modules/Automations/AutomationEdit/CloneAutomationModal/ImportAutomationModal/ImportAutomationModal';
import NewConfirmModal from './NewConfirmModal/NewConfirmModal';
import { IncreaseEmailLimitModal } from './IncreaseEmailLimitModal/IncreaseEmailLimitModal';
import { GoogleSpreadsheetModal } from './GoogleSpreadsheetModal/GoogleSpreadsheetModal';
import { AddAudienceToAutomationModal } from './AddAudienceToAutomationModal/AddAudienceToAutomationModal';
import { CongratsLeadsPurchaseModal } from '../../editor/features/beta/modules/GetLeads/LeadsSearch/PurchaseContactsTable/CongratsLeadsPurchaseModal/CongratsLeadsPurchaseModal';
import { ConfirmPurchaseLeadsModal } from '../../editor/features/beta/modules/GetLeads/LeadsSearch/PurchaseContactsTable/ConfirmPurchaseLeadsModal/ConfirmPurchaseLeadsModal';
import { ContactSalesModal } from './NewBillingModal2023/ContactSalesModal/ContactSalesModal';
import { NewBillingModal2023 } from './NewBillingModal2023/NewBillingModal2023';
import { EditWebsiteURL } from '../../dashboard/pages/XRayOnboarding/EditWebsiteURL/EditWebsiteURL';
import { ClarifyWebsiteTraffic } from '../../dashboard/pages/XRayOnboarding/ClarifyWebsiteTraffic/ClarifyWebsiteTraffic';
import { PromoteInstachamp } from '../../dashboard/pages/XRayOnboarding/PromoteInstachamp/PromoteInstachamp';
import { AnalyzeWebsiteTraffic } from '../../dashboard/pages/XRayOnboarding/AnalyzeWebsiteTraffic/AnalyzeWebsiteTraffic';
import { SignupXray } from '../../dashboard/pages/XRayOnboarding/SignupXray/SignupXray';
import { CreateMyLeadsAudienceModal } from '../../editor/features/beta/modules/Contacts/CreateMyLeadsAudienceModal/CreateMyLeadsAudienceModal';
import { WelcomeSeriesModal } from './WelcomeSeriesModal/WelcomeSeriesModal';
import { InvoicesPanel } from '../../dashboard/pages/SettingsPage/BillingPanel/InvoicesPanel/InvoicesPanel';
import { UserEditor } from '../../dashboard/pages/UserEditor/UserEditor';
import { BillingPriceTableModal } from '../../dashboard/pages/SettingsPage/BillingPanel/SubscriptionTabsArea/ActiveSubscriptionTab/BillingPageCard/BillingPriceTableModal/BillingPriceTableModal';
import { NewInfoModal } from './NewInfoModal/NewInfoModal';
import { BillingLimitsModal } from './BillingLimitsModal/BillingLimitsModal';
import { ConnectSendGridModal } from './ConnectSendGridModal/ConnectSendGridModal';
import { EmailAccountEditor } from '../../editor/features/beta/modules/Integrations/NativeIntegrations/components/EmailIntegrations/EmailAccountEditor';
import { AccountLockedModal } from './AccountLockedModal/AccountLockedModal';
import { SelectXRayModal } from './SelectXRayModal/SelectXRayModal';
import { IntegrationMappingModal } from './IntegrationMappingModal/IntegrationMappingModal';
import { ConversionURLModal } from './ConversionURLModal/ConversionURLModal';
import { AddPromocodeModal } from './AddPromocodeModal/AddPromocodeModal';
import { ValidateDNSModal } from './ValidateDNSModal/ValidateDNSModal';

// Have lookup table since components are not serializable in stores
export const MODAL_LOOKUP = {
  [MODALS_TYPE.ADMIN_ACCESS_REQUIRED]: AdminAccessRequiredModal,
  [MODALS_TYPE.CREATE_CHATBOT]: CreateBotModal,
  [MODALS_TYPE.CONFIRM_DELETE_CHATBOT]: ConfirmDeleteChatbotModal,
  [MODALS_TYPE.INVITE_USER_MODAL]: InviteUserModal,
  [MODALS_TYPE.CONNECT_PAGES_MODAL]: ConnectPagesModal,
  [MODALS_TYPE.DIALOGUE_SETTINGS_MODAL]: DialogueSettingsModal,
  [MODALS_TYPE.UNIVERSAL_UPGRADE_LANDMINE]: UniversalUpgradeModal,
  [MODALS_TYPE.REMOVE_USER_MODAL]: RemoveUserModal,
  [MODALS_TYPE.MENU_BUTTON_CONFIG_FORM]: MenuButtonConfigForm,
  [MODALS_TYPE.ADD_EMAIL_MODAL]: AddEmailModal,
  [MODALS_TYPE.TEST_CONNECTION_MODAL]: TestConnectionModal,
  [MODALS_TYPE.DEACTIVATE_AFFILIATE_MODAL]: DeactivateAffiliateModal,
  [MODALS_TYPE.DISCONNECT_PAGES_MODAL]: DisconnectPageModal,
  [MODALS_TYPE.BUTTON_CONFIG_FORM]: ButtonConfigForm,
  [MODALS_TYPE.CONNECTED_PAGE_ERROR_MODAL]: ConnectedPageErrorModal,
  [MODALS_TYPE.IMAGE_UPLOAD_FORM_MODAL]: ImageUploadFormModal,
  [MODALS_TYPE.GET_STARTED_ONBOARDING_MODAL]: GetStartedOnboardingModal,
  [MODALS_TYPE.REFRESH_ACCESS_TOKEN_ERROR_MODAL]: RefreshAccessTokenErrorModal,
  [MODALS_TYPE.ADD_PROMOTER_MODAL]: AddPromoterModal,
  [MODALS_TYPE.CREATE_COMPANY_MODAL]: CreateCompanyModal,
  [MODALS_TYPE.PERMISSIONS_HELPER_MODAL]: PermissionsHelperModal,
  [MODALS_TYPE.CONTACTS_EXPORT_MODAL]: ContactsExportModal,
  [MODALS_TYPE.CONFIRM_CHANGE_BOT_STATUS_MODAL]: ConfirmChangeBotStatusModal,
  [MODALS_TYPE.OPEN_VARIABLE_FILTER_MODAL]: VariableValuesModal,
  [MODALS_TYPE.OPEN_REACHABLE_FILTER_MODAL]: ReachableModal,
  [MODALS_TYPE.OPEN_PLATFORMS_FILTER_MODAL]: PlatformsFilterModal,
  [MODALS_TYPE.DOWNGRADE_FACEBOOK_PAGE_MODAL]: DowngradeFacebookPageModal,
  [MODALS_TYPE.NO_LINKED_AD_ACCOUNT_MODAL]: NoLinkedAdAccountModal,
  [MODALS_TYPE.CUSTOM_AUDIENCE_ERROR_MODAL]: CustomAudienceErrorModal,
  [MODALS_TYPE.GENERAL_TEXT_MODAL]: GeneralTextModal,
  [MODALS_TYPE.CONFIRM_DOWNGRADE_PROMO_MODAL]: ConfirmDowngradePromoModal,
  [MODALS_TYPE.SHARE_BOT_MODAL]: ShareBotModal,
  [MODALS_TYPE.CONFIRM_FB_DOWNGRADE_MODAL]: ConfirmFbDowngradeModal,
  [MODALS_TYPE.ACTIVATE_INACTIVE_BOT_MODAL]: ActivateInactiveBotModal,
  [MODALS_TYPE.ACTIVATE_CHANNELS_MODAL]: ActivateChannelsModal,
  [MODALS_TYPE.CONFIRM_SEND_WELCOME_MESSAGE_MODAL]:
    ConfirmSendWelcomeMessageModal,
  [MODALS_TYPE.GENERAL_CONFIRM_MODAL]: GeneralConfirmModal,
  [MODALS_TYPE.LINK_AD_ACCOUNT_MODAL]: LinkAdAccountModal,
  [MODALS_TYPE.CONFIRM_DELETE_MODAL]: ConfirmDeleteModal,
  [MODALS_TYPE.GRANT_PERMISSIONS_MODAL]: GrantPermissionsModal,
  [MODALS_TYPE.PRETTY_ERROR_MODAL]: PrettyErrorModal,
  [MODALS_TYPE.CHATBOT_LIMIT_MODAL]: ChatbotLimitModal,
  [MODALS_TYPE.BILLING_MODAL]: BillingModal,
  [MODALS_TYPE.FREE_TRIAL_UPGRADE_MODAL]: FreeTrialUpgradeModal,
  [MODALS_TYPE.FEATURE_ACTIVATION_CONGRATS_MODAL]:
    FeatureActivationCongratsModal,
  [MODALS_TYPE.MONTHLY_SENDS_WARNING_MODAL]: MonthlySendsWarningModal,
  [MODALS_TYPE.CAMPAIGN_EXCEEDS_SEND_LIMIT_MODAL]:
    CampaignExceedsSendLimitModal,
  [MODALS_TYPE.SELECT_TEAM_PAGES_MODAL]: SelectTeamPagesModal,
  [MODALS_TYPE.ADD_MORE_PAGES_TEAM_MODAL]: AddMorePagesTeamModal,
  [MODALS_TYPE.MANAGE_PAGES_MODAL]: ManagePagesModal,
  [MODALS_TYPE.CONFIRM_MANAGE_PAGES_MODAL]: ConfirmManagePagesModal,
  [MODALS_TYPE.CONFIRM_SWAP_PAGES_MODAL]: ConfirmSwapPagesModal,
  [MODALS_TYPE.ALL_SET_MODAL]: AllSetModal,
  [MODALS_TYPE.MOBIBLE_DOWNLOAD]: MobileDownload,
  [MODALS_TYPE.DIALOGUE_PICKER_NEW_MODAL]: NewDialoguePickerModal,
  [MODALS_TYPE.DIALOGUE_PICKER_MODAL]: DialoguePickerModal,
  [MODALS_TYPE.IMPORT_CONTACT_LIST_MODAL]: ImportContactListModal,
  [MODALS_TYPE.PROMO_BLASTER_MODAL]: PromoBlasterModal,
  [MODALS_TYPE.BOT_RESPONSE_SETTINGS_MODAL]: BotResponseSettingsModal,
  [MODALS_TYPE.CHAT_WIDGET_PREVIEW_MODAL]: ChatWidgetPreviewModal,
  [MODALS_TYPE.OPEN_EXPORT_MODAL]: ExportModal,
  [MODALS_TYPE.OPEN_INSTAGRAM_CONNECT_MODAL]: InstagramConnectModal,
  [MODALS_TYPE.AUDIENCES_SYNC_RESTRICTIONS_MODAL]:
    AudiencesSyncRestrictionsModal,
  [MODALS_TYPE.CONNECT_PAGES_FOLLOW_UP_MODAL]: ConnectPagesFollowUpModal,
  [MODALS_TYPE.DEC_2020_FB_API_EUROPE_CHANGES_MODAL]:
    Dec2020FbApiEuropeChangesModal,
  [MODALS_TYPE.EMAIL_SUBMISSION_MODAL]: EmailSubmissionModal,
  [MODALS_TYPE.SPREADSHEET_TEST_CONNECTION_MODAL]:
    SpreadsheetTestConnectionModal,
  [MODALS_TYPE.CONFIRM_STORY_MENTION_MODAL]: ConfirmStoryMentionModal,
  [MODALS_TYPE.INSTAGRAM_MEDIA_MODAL]: InstagramMediaModal,
  [MODALS_TYPE.MAILCHIMP_TEST_CONNECTION_MODAL]: MailchimpTestConnectionModal,
  [MODALS_TYPE.SUBSCRIPTION_PAUSING_MODAL]: SubscriptionPausingModal,
  [MODALS_TYPE.MIGRATE_TO_INSTACHAMP_THANKS_MODAL]:
    MigrateToInstachampThanksModal,
  [MODALS_TYPE.NEW_AUDIENCE_NAME_PROMPT_MODAL]: NewAudienceNamePromptModal,
  [MODALS_TYPE.OPEN_ACTIVATE_SMS_NUMBER_MODAL]: ActivateSMSNumberModal,
  [MODALS_TYPE.QUICK_QUESTION_OPT_IN_MODAL]: QuickQuestionOptInModal,
  [MODALS_TYPE.SELECT_FACEBOOK_PAGE_MODAL]: SelectFacebookPageModal,
  [MODALS_TYPE.AUDIENCE_EXTRACTOR_MODAL]: AudienceExtractorModal,
  [MODALS_TYPE.SEND_TEST_EMAIL_MODAL]: SendTestEmailModal,
  [MODALS_TYPE.CONNECT_CHANNEL_MODAL]: ConnectChannelModal,
  [MODALS_TYPE.ACTIVATE_EMAIL_ACCOUNT_MODAL]: ActivateEmailAccountModal,
  [MODALS_TYPE.EMAIL_ACCOUNT_EDITOR_MODAL]: EmailAccountEditor,
  [MODALS_TYPE.SUBSCRIBE_AFTER_FREE_TRIAL_PROMO]: SubscribeAfterTrialPromoModal,
  [MODALS_TYPE.VERIFY_EMAIL_MODAL]: VerifyEmailModal,
  [MODALS_TYPE.CLONE_AUTOMATION]: CloneAutomationModal,
  [MODALS_TYPE.IMPORT_AUTOMATION]: ImportAutomationModal,
  [MODALS_TYPE.GOOGLE_SPREADSHEET_MODAL]: GoogleSpreadsheetModal,
  [MODALS_TYPE.NEW_CONFIRM_MODAL]: NewConfirmModal,
  [MODALS_TYPE.INCREASE_EMAIL_LIMIT]: IncreaseEmailLimitModal,
  [MODALS_TYPE.ADD_AUDIENCE_TO_AUTOMATION]: AddAudienceToAutomationModal,
  [MODALS_TYPE.CONVERT_LEADS_TO_CONTACTS]: ConfirmPurchaseLeadsModal,
  [MODALS_TYPE.CONVERTED_LEADS_SUCCCESS_MODAL]: CongratsLeadsPurchaseModal,
  [MODALS_TYPE.CONTACT_SALES]: ContactSalesModal,
  [MODALS_TYPE.NEW_BILLING_MODAL_2023]: NewBillingModal2023,
  [MODALS_TYPE.EDIT_WEBSITE_URL]: EditWebsiteURL,
  [MODALS_TYPE.CLARIFY_WEBSITE_TRAFFIC_MODAL]: ClarifyWebsiteTraffic,
  [MODALS_TYPE.SIGN_UP_X_RAY_MODAL]: SignupXray,
  [MODALS_TYPE.ANALYZE_WEBSITE_TRAFFIC_MODAL]: AnalyzeWebsiteTraffic,
  [MODALS_TYPE.PROMOTE_INSTACHAMP_MODAL]: PromoteInstachamp,
  [MODALS_TYPE.CREATE_MY_LEADS_AUDIENCE_MODAL]: CreateMyLeadsAudienceModal,
  [MODALS_TYPE.WELCOME_SERIES_MODAL]: WelcomeSeriesModal,
  [MODALS_TYPE.INVOICES_MODAL]: InvoicesPanel,
  [MODALS_TYPE.EDIT_USER_MODAL]: UserEditor,
  [MODALS_TYPE.BILLING_PRICE_TABLE_MODAL]: BillingPriceTableModal,
  [MODALS_TYPE.NEW_INFO_MODAL]: NewInfoModal,
  [MODALS_TYPE.BILLING_LIMITS_MODAL]: BillingLimitsModal,
  [MODALS_TYPE.CONNECT_SENDGRID_MODAL]: ConnectSendGridModal,
  [MODALS_TYPE.ACCOUNT_IS_LOCKED_MODAL]: AccountLockedModal,
  [MODALS_TYPE.INTEGRATION_MAPPING_MODAL]: IntegrationMappingModal,
  [MODALS_TYPE.SELECT_XRAY_MODAL]: SelectXRayModal,
  [MODALS_TYPE.CONNECT_SHOPIFY_MODAL]: ConnectShopifyModal,
  [MODALS_TYPE.CONVERSION_URL_MODAL]: ConversionURLModal,
  [MODALS_TYPE.ADD_PROMOCODE_MODAL]: AddPromocodeModal,
  [MODALS_TYPE.VALIDATE_DNS_MODAL]: ValidateDNSModal,
};
